const formatSiteName = (siteName) => {
    let formatedSiteName = siteName;
    switch (siteName) {
    case 'nova88':
        formatedSiteName = 'Nova88';
        return formatedSiteName;
    case 'pica88':
        formatedSiteName = 'PICA88';
        return formatedSiteName;
    case 'ibcbet':
        formatedSiteName = 'IBCBet';
        return formatedSiteName;
    case 'bettha88':
        formatedSiteName = 'Bettha88';
        return formatedSiteName;
    case 'fifabet':
        formatedSiteName = 'FifaBet';
        return formatedSiteName;
    case 'ocean99':
        formatedSiteName = 'Ocean99';
        return formatedSiteName;
    default:
        return formatedSiteName;
    }
};

export default formatSiteName;
